import InsightsService from '@/services/benchmarks/InsightsService.js';
import { getBenchmarkId } from '@/utils';

import { insightsMutationTypes } from './mutation-types';

export const actions = {
  async fetchFanbaseEvolutionInsights({ commit, rootState, rootGetters }) {
    try {
      const groupIdListJoined = rootGetters['ui/getterGroupIdList'].join(',');

      const data = await InsightsService.getFanbaseEvolutionInsights({
        'benchmark-id': getBenchmarkId(),
        'group-id': groupIdListJoined,
        'start-date': rootState.ui.dateRange.start,
        'end-date': rootState.ui.dateRange.end,
        channel: rootState.ui.channel,
      });

      if (!Array.isArray(data)) throw new Error();

      commit(insightsMutationTypes.FANBASE_EVOLUTION_INSIGHTS, { insights: data });
    } catch (e) {
      console.error(e);
      return e;
    }
  },

  async fetchInteractionsOverTimeInsights({ commit, rootState, rootGetters }) {
    try {
      const groupIdListJoined = rootGetters['ui/getterGroupIdList'].join(',');

      const data = await InsightsService.getInteractionsOverTimeInsights({
        'benchmark-id': getBenchmarkId(),
        'group-id': groupIdListJoined,
        'start-date': rootState.ui.dateRange.start,
        'end-date': rootState.ui.dateRange.end,
        channel: rootState.ui.channel,
      });

      if (!Array.isArray(data)) throw new Error();

      commit(insightsMutationTypes.INTERACTIONS_OVER_TIME_INSIGHTS, { insights: data });
    } catch (e) {
      console.error(e);
      return e;
    }
  },
};
